export interface Note {
  id: number,
  courseId: string,
  participantId: string,
  note: string,
  lastUpdated?: Date
}

export function NoteDefaultValues(): Note {
  return {
    id:0,
    courseId: '',
    participantId: '',
    note: '',
    lastUpdated: undefined,
   }
}


